import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { startCase } from 'lodash';
import React, { useMemo } from 'react';
import { FloatingArrow, FloatingPortal } from '@floating-ui/react';
import longFormCellSelectionUtils from '@/utils/reporting/longFormCellSelection';
import environment from '@/config/environment';
import Button from '@/components/Button';
import useEditingAreasState from '@/components/Editor/hooks/useEditingAreasState';
import useEditingAreaPosition from '@/components/Editor/hooks/useEditingAreaPosition';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BLACKLIST_META_KEYS = [environment.isDevelopment ? '' : 'selectionIndex'].filter(Boolean);

const EditorPreviewTooltip = _ref => {
  let {
    actions = []
  } = _ref;
  const {
    activeSectionId,
    activeSectionEditingArea,
    activeEditingAreaMeta,
    activeClickPosition
  } = useEditingAreasState(); // Get the position of the editing area

  const {
    arrowRef,
    floatingStyles,
    context,
    elements,
    refs
  } = useEditingAreaPosition({
    activeSectionId,
    activeSectionEditingArea,
    activeClickPosition
  }); // Generate meta data for editing area tooltip

  const editingAreaMetaData = useMemo(() => {
    if (!activeEditingAreaMeta) return [];
    return Object.entries(activeEditingAreaMeta).filter(_ref2 => {
      let [key] = _ref2;
      return !BLACKLIST_META_KEYS.includes(key);
    }).map(_ref3 => {
      let [key, value] = _ref3;

      if (key === 'selection') {
        return {
          label: 'Selection',
          value: longFormCellSelectionUtils.toUserFacingSelection(value, {
            addSheetRef: `${value}`.search(/^[1-9]\./) > -1
          })
        };
      }

      return {
        label: startCase(key),
        // Capitalize key
        value
      };
    }).filter(Boolean);
  }, [activeEditingAreaMeta]);
  if (!elements.reference || typeof (activeClickPosition === null || activeClickPosition === void 0 ? void 0 : activeClickPosition.x) !== 'number' || typeof (activeClickPosition === null || activeClickPosition === void 0 ? void 0 : activeClickPosition.y) !== 'number' || (activeEditingAreaMeta === null || activeEditingAreaMeta === void 0 ? void 0 : activeEditingAreaMeta.selection) === 'missing') return null;
  return /*#__PURE__*/_jsx(FloatingPortal, {
    children: /*#__PURE__*/_jsxs("div", {
      ref: refs.setFloating,
      style: floatingStyles,
      className: styles.container,
      children: [editingAreaMetaData.length > 0 ? /*#__PURE__*/_jsx("div", {
        className: styles.data,
        children: editingAreaMetaData.map((_ref4, idx) => {
          let {
            label,
            value
          } = _ref4;
          return /*#__PURE__*/_jsxs("div", {
            className: styles.dataRow,
            children: [/*#__PURE__*/_jsx("span", {
              children: label
            }), /*#__PURE__*/_jsx("span", {
              children: value
            })]
          }, `${label}-${idx}`);
        })
      }) : null, /*#__PURE__*/_jsx("div", {
        className: styles.actions,
        children: actions.map((action, idx) => {
          if (action.hidden) return null;
          return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread(_objectSpread({
            variant: "dark",
            className: styles.action
          }, action.title && {
            title: action.title
          }), action.onClick && {
            onClick: e => {
              var _action$onClick;

              e.stopPropagation();
              (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action);
            }
          }), {}, {
            children: action.title
          }), `${action.title}-${idx}`);
        })
      }), /*#__PURE__*/_jsx(FloatingArrow, {
        ref: arrowRef,
        context: context,
        className: styles.arrow
      })]
    })
  });
};

export default EditorPreviewTooltip;